export default {
  mounted() {
    let pageAppStore = this.$store.getters.getAppStatus;

    let pageApp = {
      // currentPage: this.currentPagePath,
      currentPage: this.currentPagePath,
      previousPage: pageAppStore.currentPage
    };
    this.$store.dispatch("changeAppStatus", pageApp);
  },

  data() {
    return {};
  }
};
